import { Link, Navigate } from "react-router-dom";
import { FileText, Plus } from "lucide-react";

import { useAuth } from "@/contexts/auth";
import AdminLayout from "@/components/admin/AdminLayout";
import AdminDashboardStats from "@/components/admin/dashboard/AdminDashboardStats";
import { Button } from "@/components/ui/button";

export default function AdminDashboardPage() {
  const { isAdmin, loading: authLoading } = useAuth();

  if (authLoading) {
    return <AdminLayout title="Dashboard" loading />;
  }

  if (!isAdmin) {
    return <Navigate to="/" replace />;
  }

  return (
    <AdminLayout
      title="Dashboard"
      description="Pending work first, platform totals second."
      actions={
        <>
          <Button
            asChild
            variant="outline"
            size="sm"
            className="rounded-lg border-gray-200 text-gray-700 hover:border-whatsapp hover:text-whatsapp"
          >
            <Link to="/admin/review-listings">
              <FileText className="h-4 w-4" />
              Review queue
            </Link>
          </Button>
          <Button asChild size="sm" className="rounded-lg bg-whatsapp text-white hover:bg-whatsapp-dark">
            <Link to="/admin/create-listing">
              <Plus className="h-4 w-4" />
              Create listing
            </Link>
          </Button>
        </>
      }
    >
      <AdminDashboardStats />
    </AdminLayout>
  );
}
